import { updateShareholderGroup } from "./action";
import { ADDSHAREHOLDERS, ADDSHAREHOLDERSGROUP, ADDSHAREHOLDERSGROUP_FAILED, ADDSHAREHOLDERSGROUP_SUCCESS, ADDSHAREHOLDERS_FAILED, ADDSHAREHOLDERS_SUCCESS, ROLESLIST, ROLESLIST_FAILURE, ROLESLIST_SUCCESS, SHAREHOLDERS, SHAREHOLDERSGROUPSLIST, SHAREHOLDERSGROUPSLIST_FAILED, SHAREHOLDERSGROUPSLIST_SUCCESS, SHAREHOLDERSLIST, SHAREHOLDERSLIST_FAILED, SHAREHOLDERSLIST_SUCCESS, SHAREHOLDERS_FAILED, SHAREHOLDERS_SUCCESS, UPDATE, UPDATESHAREHOLDERS, UPDATESHAREHOLDERSGROUP, UPDATE_SHAREHOLDERSGROUP_FAILURE, UPDATE_SHAREHOLDERSGROUP_SUCCESS, UPDATE_SHAREHOLDERS_FAILURE, UPDATE_SHAREHOLDERS_SUCCESS, UPDATE_SH_FAILURE, UPDATE_SH_SUCCESS } from "./actionTypes";

let initialState = {
    shareholders: [],
    shareholderslist: [],
    roles: [],
    addShareholder: '',
    updateShareholder: '',
    loading: false,
    success: false,
    error: '',
    shareholdersgroupslist: [],
    addShareholderGroup: '',
    updateShareholderGroup: '',
}

export const shareholdersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHAREHOLDERS: return {
            ...state,
            shareholders: [],
            loading: true,
            success: false,
            error: ''
        }
        case SHAREHOLDERS_SUCCESS: return {
            ...state,
            shareholders: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SHAREHOLDERS_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case SHAREHOLDERSLIST: return {
            ...state,
            shareholderslist: [],
            loading: true,
            success: false,
            error: ''
        }
        case SHAREHOLDERSLIST_SUCCESS: return {
            ...state,
            shareholderslist: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SHAREHOLDERSLIST_FAILED: return {
            ...state,
            shareholderslist: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ROLESLIST: return {
            ...state,
            roles: [],
            loading: true,
            success: false,
            error: ""
        }
        case ROLESLIST_SUCCESS: return {
            ...state,
            roles: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ROLESLIST_FAILURE: return {
            ...state,
            roles: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ADDSHAREHOLDERS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADDSHAREHOLDERS_SUCCESS: return {
            ...state,
            addShareholder: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADDSHAREHOLDERS_FAILED: return {
            ...state,
            addShareholder: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATESHAREHOLDERS: return {
            ...state,
            updateShareholder: '',
            loading: true,
            success: false,
            error: ""
        }
        case UPDATE_SHAREHOLDERS_SUCCESS: return {
            ...state,
            updateShareholder: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SHAREHOLDERS_FAILURE: return {
            ...state,
            updateShareholder: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case SHAREHOLDERSGROUPSLIST: return {
            ...state,
            shareholdersgroupslist: [],
            loading: true,
            success: false,
            error: ''
        }
        case SHAREHOLDERSGROUPSLIST_SUCCESS: return {
            ...state,
            shareholdersgroupslist: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SHAREHOLDERSGROUPSLIST_FAILED: return {
            ...state,
            shareholdersgroupslist: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ADDSHAREHOLDERSGROUP: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADDSHAREHOLDERSGROUP_SUCCESS: return {
            ...state,
            addShareholderGroup: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADDSHAREHOLDERSGROUP_FAILED: return {
            ...state,
            addShareholderGroup: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATESHAREHOLDERSGROUP: return {
            ...state,
            updateShareholderGroup: '',
            loading: true,
            success: false,
            error: ""
        }
        case UPDATE_SHAREHOLDERSGROUP_SUCCESS: return {
            ...state,
            updateShareholderGroup: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SHAREHOLDERSGROUP_FAILURE: return {
            ...state,
            updateShareholderGroup: '',
            loading: false,
            success: false,
            error: action.payload
        }
        default:
            return state
    }
}